import { filter, map, pluck, pairwise, withLatestFrom, distinctUntilChanged } from 'rxjs/operators';

const MIN_SECONDS_SEEK_THRESHOLD = 2;

const calculateProgressDelta = ([prev, next]) => Math.abs(prev - next);

const createPlaybackSeekStream = (playerPlaybackUpdate$, resumePointsUpdate$) =>
    playerPlaybackUpdate$
        .pipe(
            pluck('currentTime'),
            distinctUntilChanged(),
            pairwise(),
            map(calculateProgressDelta),
            filter(delta => delta > MIN_SECONDS_SEEK_THRESHOLD),
            withLatestFrom(resumePointsUpdate$),
            filter(([, { isEnabled }]) => isEnabled),
            withLatestFrom(playerPlaybackUpdate$),
            map(([, { currentTime }]) => currentTime),
        );

export default createPlaybackSeekStream;
